module.exports = __webpack_public_path__ + "img/main4.08e1daac.png";